module.exports = __webpack_public_path__ + "img/footer-bg-mobile.d4fd4f20.png";